import api from './api';

export const billingImportService = {
  /**
   * Parse a CSV/XLSX file without writing anything. The preview payload is a
   * read-only view that is never sent back, so it keeps the API's snake_case
   * shape and ImportPreviewTable reads it directly.
   */
  preview: async (file, onUploadProgress) => {
    const fd = new FormData();
    fd.append('file', file);
    const { data } = await api.post('/billing/imports/preview', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress,
    });
    return data.data;
  },

  commit: async ({ previewToken, decisions, overwriteExisting, skipRowsWithErrors, importInvalidGstin, createDraftInvoices }) =>
    (await api.post('/billing/imports/commit', {
      preview_token: previewToken,
      decisions, // [{ row_numbers, action: 'merge'|'create', client_id? }]
      overwrite_existing: overwriteExisting,
      skip_rows_with_errors: skipRowsWithErrors,
      import_invalid_gstin: importInvalidGstin,
      create_draft_invoices: createDraftInvoices,
    })).data.data,

  history: async (params = {}) => (await api.get('/billing/imports', { params })).data.data,
};
